import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import { DriversService } from 'src/app/component/drivers/drivers-service/drivers-service';
import { FleetService } from 'src/app/component/fleet/fleet-service/fleet.service';
import { ServiceAreasService } from 'src/app/component/service-areas/service-areas-service/service-areas.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { sweetAlert } from 'src/app/utils/swal';
import { AssigTripsService } from '../../../assigntrips-service/assigntrips-service';

@Component({
  selector: 'app-planner-driver-mapper-add',
  templateUrl: './planner-driver-mapper-add.component.html',
  styleUrls: ['./planner-driver-mapper-add.component.css']
})
export class PlannerDriverMapperAddComponent implements OnInit {
  user;
  driverList;
  status = "active";
  preDriver = {};
  selectedDriver;
  plannerTemplateForm: FormGroup;
  templateId;
  preFleet;
  submitted = false;
  preServiceAreas = {};
  serviceAreasList = [];
  driverWithFleets = [];
  driverWithoutFleets = [];
  filteredDriverList = [];
  days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];



  constructor(
    private fb: FormBuilder,
    private fleetService: FleetService,
    private sharedDataService: SharedDataService,
    private driverService: DriversService,
    private assignTripsService: AssigTripsService,
    private activatedRoute: ActivatedRoute,
    private serviceArea: ServiceAreasService,
    private router: Router
  ) { }

  ngOnInit() {
    this.activatedRoute.params
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((params) => {
        this.templateId = params["id"];
      });

    this.plannerTemplateForm = this.fb.group({
      driver: ['',Validators.required],
      serviceAreas: ['',Validators.required],
      shifts: this.fb.array([]),
    });

    this.getUser();
    this.addPreShifts()

  }


  getUser() {
    this.sharedDataService.getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.user = data;
          this.getDriverList();
          this.getServiceAreas();
        }
      });
  }

  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.serviceAreasList = data;
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        });
  }


  getDriverMapperById() {
    this.assignTripsService
      .getDriverPlannerTemplateById(this.templateId)
      .subscribe(data => {
        if (data) {
          this.filteredDriverList = this.driverList.filter(u1 => data.driver === u1._id);
          this.plannerTemplateForm.patchValue(data);
          if (data.shifts) {
            this.updateShift(data.shifts);
          }
        }
      });
  }

  getDriverList() {
    this.driverService.getDrivers(this.user._id, 'active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.driverList = data;
            this.filteredDriverList = this.driverList
            this.preDriver = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
          this.getTemplates();
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  getTemplates() {
    this.assignTripsService
      .getDriverPlannerTemplates()
      .subscribe(data => {
        if (data && data.length) {

          const templateDrivers = data.map(item=>{
            return item.driver
          });
          if (this.templateId) {
            this.getDriverMapperById();
          } else {
            this.filteredDriverList = this.driverList.filter(u1 =>
              !templateDrivers.some(_id => u1._id === _id)
            );
          }
        }

      });
  }


  onSave() {
    this.submitted = true;
    if (this.plannerTemplateForm.invalid || !this.singleDayShift()) {
      return;
    }
    const payload = this.plannerTemplateForm.value;

    this.assignTripsService
      .saveDriverPlannerTemplate(payload, this.templateId)
      .subscribe(data => {
        if (data) {
          this.router.navigateByUrl("planner/mapper");
        }
      });
  }

  onChangeShiftStart(evt, shift) {
    shift.patchValue({
      checkin: moment(evt).format("HH:mm")
    });

    if (shift.controls.perCheckin.value.isAfter(shift.controls.preCheckout.value)) {
      shift.patchValue({
        preCheckout: moment(evt),
        checkout: moment(evt).format("HH:mm")
      });
    }
  }

  onChangeShiftEnd(evt, shift) {
    shift.patchValue({
      checkout: moment(evt).format("HH:mm")
    });

    if (shift.controls.perCheckin.value.isAfter(shift.controls.preCheckout.value)) {
      shift.patchValue({
        preCheckin: moment(evt),
        checkin: moment(evt).format("HH:mm")
      });
    }
  }


  getMinDate() {
    return moment().startOf('day');
  }

  getMaxDate() {
    return moment().endOf('day');
  }

  getStartMinDate(val) {
    return moment(val);
  }


  addPreShifts() {
    const items = this.plannerTemplateForm.get('shifts') as FormArray;
    for (const day of [0, 1, 2, 3, 4, 5, 6]) {

      items.push(
        this.fb.group({
          perCheckin: [moment().startOf('day')],
          preCheckout: [moment().endOf('day')],
          checkin: [moment().startOf('day').format("HH:mm"), Validators.required],
          checkout: [moment().endOf('day').format("HH:mm"), Validators.required],
          shiftAlign: ['opener', Validators.required],
          day: [day, Validators.required],
          isEnabled: [false]
        })
      );

    }
  }

  updateShift(preShifts?) {
    const items = this.plannerTemplateForm.get('shifts') as FormArray;
    if (preShifts) {
      for (let [index, shift] of preShifts.entries()) {
        items.at(index).patchValue(
          {
            perCheckin: moment().startOf('day').hours(shift.checkin.split(":")[0]).minutes(shift.checkin.split(":")[1]).seconds(0),
            preCheckout: moment().startOf('day').hours(shift.checkout.split(":")[0]).minutes(shift.checkout.split(":")[1]).seconds(0),
            checkin: moment().startOf('day').hours(shift.checkin.split(":")[0]).minutes(shift.checkin.split(":")[1]).seconds(0).format("HH:mm"),
            checkout: moment().startOf('day').hours(shift.checkout.split(":")[0]).minutes(shift.checkout.split(":")[1]).seconds(0).format("HH:mm"),
            shiftAlign: shift.shiftAlign,
            day: shift.day,
            isEnabled: shift.isEnabled
          }
        );

      }
    }
  }


  singleDayShift() {
    let isDayShiftEnabled = false;
    for (let item of this.plannerTemplateForm.value.shifts) {
      if (item.isEnabled) {
        isDayShiftEnabled = true;
        break;
      }
    }
    return isDayShiftEnabled;
  }




  get form() {
    return this.plannerTemplateForm.controls;
  }
  get shiftForm() {
    return this.plannerTemplateForm.controls.shift['controls'];
  }
  get shiftsForm() {
    return this.plannerTemplateForm.get('shifts') as FormArray;
  }

  ngOnDestroy() {
  }


}
